
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaTrash,FaPlus } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import {Mandate} from '../../compnents/formcomp';
import { Message } from 'primereact/message';


const Addbudgethrs = ({tabname}) => {
    const toast = useRef(null);
    const msgs = useRef(null);
    const [formData, setFormData] = useState({
        client: '',
        subclient:'',
        budgethours:0,
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [subclientdata,setSubclientdata] = useState({}); 
    const [popupvisible,setVisibility] = useState(false);
    const [adjustmentvalues,setadjustmentvalues] = useState({});
    const [budgetobjdata,setbudgetobjdata] = useState({});
    const [budgetobjdatatemp,setbudgetobjdatatemp] = useState({});
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        getallclient();
        // getbudgethours();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
    
            if(name == 'client'){
                getallsubclient({client:value}); 
                setbudgethrs(0);
            }
            if(name == 'subclient'){
                console.log(value);
                if(value == ''){
                     return;
                }
                let subclientval = JSON.parse(value);
                setSubclientdata(subclientval);
                let objdata = {'client':formData.client,'subclient':subclientval};
                setbudgetobjdatatemp(objdata);
                getbudgethourstemp(objdata);
                setFormData((prevData)=>({...prevData,budgethours:subclientval.budget_hours}));
            }
    
            if(name == 'budgethours'){
                setFormData((prevData) => ({...prevData,budgethours:value}));
            }
        }catch(e){
            console.log(e);
        }
        
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.client == '') {
          newErrors.client = 'Client name is required';
          valid = false;
        }

        if (formData.subclient == '') {
            newErrors.subclient = 'Subclient name is required';
            valid = false;
        }
        
        if (formData.budgethours == '') {
            newErrors.budgethours = 'Budgethours is required';
            valid = false;
        }

        setErrors(newErrors);
        return valid; 
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
         }
        try{
            let subobj = JSON.parse(formData.subclient);
            let obj ={
                'BilledMinutes':'',
                'budget_hours':subobj.budget_hours,
                'budget_hours_model':formData.budgethours,
                'client':formData.client,
                'remaining_hrs':subobj.remaining_hrs,
                'subclient':subobj.subclient  
            }; 
            // console.log(obj);
            addbudgethours({obj});
        }catch(e){
           console.log(e);
        }
    };

   

    function addbudgethours({obj}){
       adminService.addbudgethours({obj:obj}).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Budget", detail:`Budget hours updated successfully!`, life: 3000});
                // getbudgethours();
                getbudgethourstemp(budgetobjdatatemp);
                setFormData({budgethours:'',subclient:'',client:''});
            }else{
                toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not updated`, life: 3000});
                setFormData({budgethours:'',subclient:'',client:''});
            }
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not updated`, life: 3000});
            // console.log("error");
            // console.log(error);
        });
    } 

    function getbudgethours(){
        let emparr = [];
        setloading(false);
        adminService.getbudgethours().then((response)=>{
            setDatacomp(response.data.data);
            setDatacomptemp(response.data.data);
            setloading(true);
            setDatastate(true);
        }).catch((error)=>{
            setDatacomp([]);
            setDatacomptemp([]); 
            setloading(true);
            setDatastate(true);
        });   
    }

    function getbudgethourstemp(obj){
        let emparr = [];
        setloading(false);
        adminService.getbudgethourstemp({formdata:obj}).then((response)=>{
            setDatacomp(response.data.data);
            setDatacomptemp(response.data.data);
            setloading(true);
            setDatastate(true);
            console.log(obj,"budget hours");
            setbudgetobjdata(obj);
        }).catch((error)=>{
            setDatacomp([]);
            setDatacomptemp([]); 
            setloading(true);
            setDatastate(true);
        });   
    }

    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           console.log(response.data.data);
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    function getallsubclient({client}){
        let emparr = [];
        adminService.getallsubclienttemp({client:client}).then((response)=>{
           // console.log(response.data.data);
           if(response.status == 200){
              response.data.data.forEach((value,index)=>{
                emparr.push(<option value={JSON.stringify(value)}>{value.subclient}</option>);
               });
           }           
           setsubClientscomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    const searchclients = (e) =>{
        let value = e.target.value; 
        let _userdatalist = datacomptemp;
        
        const searchRegexClient    = new RegExp(value.toLowerCase());
        const searchRegexSubclient = new RegExp(value.toLowerCase());
        const foundItems = _userdatalist.filter(item => 
          // (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
         (searchRegexClient.test(item.client.toLowerCase()) || searchRegexSubclient.test(item.subclient.toLowerCase()))
        );
      
        if (foundItems.length > 0) {
            console.log('items found.');
            setDatacomp(foundItems);
        } else {
            console.log('No items found.');
            setDatacomp([]);
        }
    }

    function handlechangeddata(e){
        const { name, value } = e.target;
        setadjustmentvalues((prevData) => ({
        ...prevData,
        [name]: value,
        }));
         
        let newval = 0;
        if(name == 'budget_hours2'){
            if(value.length > 0){
                newval = (parseFloat(adjustmentvalues['budget_hours_temp']) + parseFloat(value));
                setadjustmentvalues((prevData)=> ({...prevData,budget_hours:newval}))
            }else{
                setadjustmentvalues((prevData)=> ({...prevData,budget_hours:adjustmentvalues['budget_hours_temp']}));
            }
        }
        

        console.log(name);
    }

    function handleSubmitform2(e){
        e.preventDefault(); 
        // console.log('adjustment values');
        // console.log(adjustmentvalues);
        let obj = {
            'data': adjustmentvalues
        };
        timesheetService.updatebudgethours(obj).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Budget", detail:`Budget hours updated successfully!`, life: 3000});
                getbudgethourstemp(budgetobjdata);
                setVisibility(false); 
            }else{
                toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not updated`, life: 3000}); 
                setVisibility(false);
            }
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Budget", detail:`Error`, life: 3000});
            setVisibility(false);  
        }); 
    }



    function editbudgethrs(obj){
      console.log("edit budget hours"); 
    //   console.log(obj); 
      setadjustmentvalues(obj);

      setVisibility(true); 
    }

    function resetbudgethours(id){
        let obj = {'id':id};
        timesheetService.resetbudgethours(obj).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Budget", detail:`Budget hours reset successfully!`, life: 3000});
                getbudgethourstemp(budgetobjdata);
            }else{
                toast.current.show({severity:'error', summary: "Budget", detail:`Budget hours not reset!`, life: 3000});  
            }
        }).catch(()=>{
            toast.current.show({severity:'error', summary: "Budget", detail:`error!`, life: 3000});  
        });
        
    }

    function displaydata(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            // console.log(value.name);
            emparr.push(<tr>
                 <td>{value.id}</td>
                 <td>{value.client}</td>
                 <td>{value.subclient}</td>
                 <td>{value.budget_hours}</td>
                 <td>{value.created_at}</td>
                 <td>{value.allowed != 'allowed' ? 'Disabled' : 'Enabled'}</td>
                 <td>
                    <button className='btn btn-success' onClick={() => editbudgethrs(value)}><FaEdit/></button>
                    <button className='btn btn-danger' onClick={()=>resetbudgethours(value.id)}><FaTrash/></button>
                 </td>
            </tr>);
        });    
        return emparr;
    }

 return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
            <Toast ref={toast} />
            <div className="card flex justify-content-center" style={{border:'none'}}>
                <Message severity="info" text="Please update first subclient budget hours from edit button if you see multiple subclient" />
            </div>
            <br/>
               
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className="col-md-3">
                        <label className='pull-left'>Client</label>
                        <br/>
                        <select className='custom-dropdown-style' value={formData.client} name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           {clientcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>Sub-client</label>
                        <br/>
                        <select className='custom-dropdown-style' value={formData.subclient} name="subclient" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Subclient</option>
                           <option value={JSON.stringify({'subclient':'all','budget_hours':''})}>All</option>
                           {subclientscomp}
                        </select>
                        {errors.subclient && <span className='error'>{errors.subclient}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>Budget Hrs</label>
                        <br/>
                        <input type='number' value={formData.budgethours} name='budgethours' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {errors.budgethours && <span className='error'>{errors.budgethours}</span>}
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            {/* {console.log(subclientdata)} */}
                            {subclientdata.subclient == 'all' ? (<></>) : (<Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' />)}
                        </div>
                     </div>
                </div>
                </form>
            </div>

            <Dialog header="Edit Budget hours" position='top' visible={popupvisible} style={{ width: '60vw' }} onHide={() => setVisibility(false)}>
               <form onSubmit={(e) => handleSubmitform2(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                     <div className='col-md-3'>
                        <label><Mandate/>Client</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.client}/>    
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>Subclient</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.subclient}/>    
                     </div>
                     <div className='col-md-2'>
                        <label><Mandate/>Budget hours</label><span></span> 
                        <div className='flex' style={{display: 'flex',alignItems: 'center'}}>
                            <input type="text" disabled={true} className='form-control' name="budget_hours" value={adjustmentvalues.budget_hours} />
                            <FaPlus/>
                        </div>
                        
                     </div>
                     
                     <div className='col-md-2'>
                        <label><Mandate/>Add New value</label><span></span> 
                        <input type="text" className='form-control' name="budget_hours2"  onChange={(e) => handlechangeddata(e)}/>
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Wef Date</label><span></span> 
                        <input type="date"  value={adjustmentvalues.date} name="date" onChange={(e) => handlechangeddata(e)} className='form-control' />
                        {/* <Calendar  value={adjustmentvalues.date} name="date" onChange={(e) => handlechangeddata(e)} className='calender-custom-style' /> */}
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Status</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.allowed != 'allowed' ? 'Disabled' : 'Enabled'}/>    
                     </div>
                  </div> 
                  <br/>  
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                           <Button type="submit" label="Save" severity="success" rounded />
                          </span>
                          <span>
                          <Button type="button" onClick={() => setVisibility(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>
            <div className='card card-custom-style card-style-padding'>
              <div className='row' style={{paddingBottom:'10px'}}>
                    <div className='col-md-3 mb-2'>
                     <span className="p-input-icon-left pull-left">
                        {/* <i className="pi pi-search" /> */}
                        <FaSearch />
                        <InputText placeholder="Press and Enter"  onKeyDown={(e)=>{searchclients(e)}}/>
                     </span> 
                    </div>
                    <br/>
                </div>
               
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col">Subclient</th>
                                <th scope="col">Budgethrs</th>
                                <th scope="col">Updated at</th>
                                <th scope="col">Subclient Status</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displaydata()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Addbudgethrs;
